<template>
  <article class="Product mcp">

    <LazyHydrate when-idle >
      <div class="ProductHydates-breadcrumb">
        <!-- Breadcrumb -->
        <BreadCrumbs :breadcrumbs="product.breadcrumbs" v-if="succeed === true"></BreadCrumbs>
        <Skeleton v-else ></Skeleton>
      </div>
    </LazyHydrate>

    <!-- Loader -->
    <McpWheelLoader
      :display="loadSpinner"
    />

    <!-- Modal product added to cart -->
    <ModalCartAdded
      v-if="showModalCartAdded"
      :showModal="showModalCartAdded"
      @Modal::close="closeAddedCartModal"
    ></ModalCartAdded>

    <div class="desktopOnly">
      <div class="Product-fixedMenu">
        <ProductMenu :menuProduct="menuProduct" :class="{ display: isFixed }"></ProductMenu>
      </div>
    </div>

    <div class="mobileOnly">
      <!-- FLash sell -->
      <ProductShippingFlashSell></ProductShippingFlashSell>
    </div>
    <div class="container-product-background container-arrow">
      <!-- Intro -->
      <div class="Product-intro container">
        <div class="Product-introLeft">
          <LazyHydrate when-idle>
            <div class="ProductHydates-productGallery ProductHydates-productPresentation">
              <!-- Gallery -->
              <ProductPresentation v-if="succeed === true"></ProductPresentation>
              <Skeleton v-if="succeed === false"></Skeleton>
              <Skeleton v-if="succeed === false"></Skeleton>
              <Skeleton v-if="succeed === false"></Skeleton>
            </div>
          </LazyHydrate>

          <LazyHydrate when-idle>
            <div class="ProductHydates-productGallery">
              <!-- Gallery -->
              <ProductGallery v-if="succeed === true"></ProductGallery>
              <Skeleton v-if="succeed === false"></Skeleton>
            </div>
          </LazyHydrate>

          <!-- trigger for the sticky product menu -->
          <div data-trigger-sticky></div>

          <LazyHydrate when-idle>
            <div class="container">
              <!-- Legend -->
              <ProductLegend class="desktopOnly" v-if="succeed === true"></ProductLegend>
              <Skeleton v-if="succeed === false"></Skeleton>
              <Skeleton v-if="succeed === false"></Skeleton>
            </div>
          </LazyHydrate>
        </div>
        <div class="Product-introRight">
          <LazyHydrate when-idle>
            <div class="ProductHydates-productShipping">
              <!-- Shipping -->
              <ProductShipping 
                v-if="succeed === true"
                :hasDeliveryStrate="hasDeliveryStrate"
                :hasInstallationStrate="hasInstallationStrate"
                :fromProductPage="true"
              ></ProductShipping>
              <Skeleton v-if="succeed === false"></Skeleton>
              <Skeleton v-if="succeed === false"></Skeleton>
              <Skeleton v-if="succeed === false"></Skeleton>
            </div>
          </LazyHydrate>
        </div>
      </div>

    </div>

    <!-- caracteristics -->
    <div class="Product-menuTarget" data-links="caractéristiques" id="caracteristics"></div>
    <LazyHydrate when-idle>
      <div class="container mobileOnly">
        <!-- Legend -->
        <ProductLegend v-if="succeed === true"></ProductLegend>
      </div>
    </LazyHydrate>
    <LazyHydrate when-visible>
      <div class="ProductHydates-productCaracteristics ProductHydates-bordered">
        <ProductCaracteristics v-if="succeed === true"></ProductCaracteristics>
      </div>
    </LazyHydrate>

    <!-- Reviews -->
    <LazyHydrate when-visible>
      <div class="ProductHydates-productReviews ProductHydates-bordered">
        <ProductReviews data-scroll="reviews" v-if="succeed === true" />
      </div>
    </LazyHydrate>

    <LazyHydrate when-visible>
      <div class="ProductHydates-productBlocks">
        <!-- Blocks -->
        <ProductBlocks v-if="succeed === true" />
      </div>
    </LazyHydrate>

    <LazyHydrate when-visible>
      <div class="ProductHydates-productRelated">
        <!-- Related -->
        <ProductRelated
          data-scroll="relateds"
          :id="productId"
          v-if="succeed === true"
        ></ProductRelated>
      </div>
    </LazyHydrate>

    <LazyHydrate when-visible>
      <div class="ProductHydates-breadcrumb">
        <!-- Breadcrumb -->
        <BreadCrumbs :breadcrumbs="product.breadcrumbs" v-if="succeed === true"></BreadCrumbs>
      </div>
    </LazyHydrate>

    <ButtonFixedAction
      v-if="productBillInfo && productCurrentTva && succeed === true"
      :text="product.name"
      :actionName="'submit-form'"
      :originalPrice="productBillInfo.originalPrice[productCurrentTva]"
      :specialPrice="productBillInfo.specialPrice[productCurrentTva] + additionalInfo"
      :ecoTaxe="productBillInfo.ecoTaxe"
    >
    </ButtonFixedAction>

    <ScrollToTop></ScrollToTop>
  </article>

  <!--  <div class="skeleton-container" v-else>-->
  <!--    <Skeleton class="skeleton-left-block"> </Skeleton>-->
  <!--    <Skeleton class="skeleton-right-block"> </Skeleton>-->
  <!--  </div>-->
</template>

<script>
import BreadCrumbs from "@/components/BreadCrumbs/BreadCrumbs.vue";
import ScrollToTop from "@/components/ScrollToTop/ScrollToTop.vue";
import ProductMenu from "@/components/Product/ProductMenu/ProductMenu.vue";
import ProductPresentation from "@/components/Product/ProductPresentation/ProductPresentation.vue";
import ProductLegend from "@/components/Product/ProductLegend/ProductLegend.vue";
import ProductCaracteristics from "@/components/Product/ProductCaracteristics/ProductCaracteristics.vue";
import ProductGallery from "@/components/Product/ProductGallery/ProductGallery.vue";
import ProductShipping from "@/components/Product/ProductShipping/ProductShipping.vue";
import ProductRelated from "@/components/Product/ProductRelated/ProductRelated.vue";
import ProductReviews from "@/components/Product/ProductReviews/ProductReviews.vue";
import ProductBlocks from "@/components/Product/ProductBlocks/ProductBlocks.vue";
import ProductShippingFlashSell from "@/includes/Product/ProductShippingFlashSell/ProductShippingFlashSell.vue";
import ButtonFixedAction from "@/components/ButtonFixedAction/ButtonFixedAction.vue";
import Skeleton from "@/components/Skeleton/Skeleton.vue";
import McpWheelLoader from '@/components/Loaders/McpWheelLoader.vue';
import ModalCartAdded from "@/components/Modal/ModalCartAdded.vue";

import LazyHydrate from "vue-lazy-hydration";
import { mapGetters, mapActions } from "vuex";

import setStoreMixin from "@/mixins/setStoreMixin";
import stickyMixinByTrigger from "@/mixins/stickyMixinByTrigger";
import getProductMixin from "@/mixins/actions/product/getProductMixin";
import storeCodeMixin from "@/mixins/storeCodeMixin";

import "@/globals.js";
import "@/assets/styles/mcp/_main.scss";
import "./Product.scss";
import EventBus from "@/event-bus";

export default {
  
  name: "Product",

  mixins: [setStoreMixin, stickyMixinByTrigger, getProductMixin, storeCodeMixin],

  components: {
    BreadCrumbs,
    ScrollToTop,
    ProductMenu,
    ProductPresentation,
    ProductLegend,
    ProductCaracteristics,
    ProductGallery,
    ProductShipping,
    ProductRelated,
    ProductBlocks,
    ProductReviews,
    ProductShippingFlashSell,
    ButtonFixedAction,
    Skeleton,
    LazyHydrate,
    ModalCartAdded,
    McpWheelLoader,
  },

  data() {

    return {
      menuProduct: [],
      hasRelateds: false,
      loadSpinner: false,
      hasDeliveryStrate: false,
      hasInstallationStrate: false,
      showModalCartAdded: false,
    };
  },

  computed: {
    ...mapGetters({ productBillInfo: "getProductBillInfo" }),
    ...mapGetters({ productCurrentTva: "getProductTVAForCurrentDelivery" }),
    ...mapGetters({ additionalInfo: "getPreprendCartAdditionalInfo" }),
    ...mapGetters({ productReviewsAverage: "getProductReviewsAverage" }),
  },

  props: ['productdatas'],

  async mounted() {
    EventBus.$on("loadProductSpinner", () => this.toggleProductSpinner())
    EventBus.$on("open-modal-addedCart", () => this.openAddedCartModal())
    
    let productdatas = JSON.parse(this.productdatas);
    await this.getProduct(productdatas);
    
    this.createProductMenu();
    
    if(location.hash === '#reviews') {
      window.scrollTo(0, document.getElementById("reviews").offsetTop - 200 + document.getElementById("app").offsetTop + 320);
    }
    
    this.$root.$on('stratesProductLoaded', (strates) => { // here you need to use the arrow function
      strates.forEach(strate => {
        let title = '';
        let key = '';
        let adjustmentscroll = +300;
        if(typeof strate.title_choose != 'undefined') {
          title = strate.title_choose.replace(/<[^>]*>?/gm, '');
          key = 'choose';
          adjustmentscroll -= 120;
        }
        else if(typeof strate.main_title_why_us != 'undefined') {
          title = strate.main_title_why_us.replace(/<[^>]*>?/gm, '');
          key = 'why_us';
          adjustmentscroll = +200;
        }
        else if(typeof strate.main_title_delivery != 'undefined') {
          title = strate.main_title_delivery.replace(/<[^>]*>?/gm, '');
          key = 'delivery';
          this.hasDeliveryStrate = true;
          adjustmentscroll = +200;
        }
        else if(typeof strate.title_header != 'undefined') {
          title = strate.title_header.replace(/<[^>]*>?/gm, '');
          key = 'header_installation';
          this.hasInstallationStrate = true;
          adjustmentscroll -= 130
        }
        else if(typeof strate.title_footer != 'undefined') {
          title = strate.title_footer.replace(/<[^>]*>?/gm, '');
          key = 'footer_installation';
        }
        if(this.hasRelateds === true) {
          this.menuProduct.splice((this.menuProduct.length-1), 0, {
            name: this.capitalize(title),
            link: key,
            adjustmentscroll: adjustmentscroll
          });
        }
        else {
          this.menuProduct.push({
            name: this.capitalize(title),
            link: key,
            adjustmentscroll: adjustmentscroll
          });
        }

      });
    });

    this.removeSkeleton();
  },

  methods: {
    ...mapActions({ setTvaProfils: "setTvaProfils" }),

    createProductMenu() {
      const menuProduct = [];
      document.querySelectorAll("[data-links]").forEach(el => {
        menuProduct.push({
          name: this.capitalize(el.getAttribute("data-links")),
          link: el.getAttribute("id"),
        });
        if(el.getAttribute("id") == 'relateds') {
          this.hasRelateds = true;
        }
      });

      this.menuProduct = menuProduct;
    },
    capitalize (s) {
      if (typeof s !== 'string') return ''
      return s.charAt(0).toUpperCase() + s.slice(1)
    },
    toggleProductSpinner() {
      this.loadSpinner = !this.loadSpinner;
    },

    openAddedCartModal () {
      this.showModalCartAdded = true;
    },

    closeAddedCartModal() {
      this.showModalCartAdded = false;
    },
    // Remove the skeleton loader from magento page (view.phtml)
    removeSkeleton() {
      document.body.classList.add('product-loaded');
    },
  },

  created() {
    this.setTvaProfils(JSON.parse(this.productdatas).prices.price)
  },
};
</script>
